import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from '@/util/SBAPI';
import SBTextbox from './SBTextbox.vue'
import SBButtonGeneral from './SBButtonGeneral.vue'
import SBCheckbox from './SBCheckbox.vue'
import SBButtonClosed from './SBButtonClosed.vue'
import SBSNSIcon from './SBSNSIcon.vue'
import SBText from './SBText';

@Component({
    components: {
        SBTextbox, SBButtonGeneral, SBCheckbox, SBButtonClosed, SBSNSIcon, SBText,
    },
})
export default class SBUserPlan extends Mixins(SBComponentVue) {

    public created() { }

    @Prop({
        type: String,
        default: ""
    })
    public mode !: "MYMAGE" | "USRPLAN";

    public update: boolean = false;

    public editCount: number = 1;

    public error: string = "";

    @Prop({
        type: Boolean,
        default: false
    })
    public term1 !: boolean;

    @Prop({
        type: String,
        default: "",
    })
    public paymentMethod!: string;

    @Emit("setTerm1")
    public setTerm1(val: boolean) {
        return val;
    }

    @Emit("setTerm2")
    public setTerm2(val: boolean) {
        return val;
    }

    public get count(): number {
        if (this.update) {
            return this.editCount;
        } else {
            return this.value.count;
        }
    }

    public set count(val: number) {
        if (this.update) {
            this.editCount = val;
        } else {
            this.value.count = val;
            this.input(this.value);
        }
    }

    @Prop({
        type: Object,
        default: (): SBAPI.UserPlan => {
            return {
                "count": -100,
                "plan": SBAPI.plan(),
            }
        },
    })
    public value !: SBAPI.UserPlan;

    @Emit("input")
    public input(val: SBAPI.UserPlan) {
        return val;
    }

    public changeButton() {
        this.update = true;
        this.editCount = this.value.count;
    }

    public deleteButton() {
        this.$router.push("/mypage/plan/" + this.value.plan.artist.slug + "/" + this.value.plan.id + "/delete");
    }

    public updateButton() {
        if (this.editCount == 0) {
            this.error = "申込個数を1個以上にしてください。";
        } else {
            this.error = "";
            this.value.count = this.editCount;
            this.input(this.value);
        }
        this.update = false;
    }

}